<fui-rows [formGroup]="editService.formGroup">
    <fui-row>
        <fui-two-columns>
            <fui-column>
                <fui-tandem-field>
                    <wbo-single-select-edit-control [formControlName]="'best'"
                                                    [(ngModel)]="model.data['best']"
                                                    [allowClearSelectionOption]="false">
                        <wbo-select-options>
                            <wbo-select-option [value]="true"
                                               label="wbo.best-worst-sellers-report.option.best.best-sellers"></wbo-select-option>
                            <wbo-select-option [value]="false"
                                               label="wbo.best-worst-sellers-report.option.best.worst-sellers"></wbo-select-option>
                        </wbo-select-options>
                    </wbo-single-select-edit-control>
                    <wbo-numeric-edit-control formControlName="limit" [(ngModel)]="model.data['limit']">
                    </wbo-numeric-edit-control>
                </fui-tandem-field>
            </fui-column>
            <fui-column>
                <wbo-single-select-edit-control [formControlName]="'orderBy'"
                                                [(ngModel)]="model.data['orderBy']"
                                                [allowClearSelectionOption]="false">
                    <wbo-select-options>
                        <wbo-select-option [value]="'Quantity'"
                                           label="wbo.best-worst-sellers-report.option.order.quantity"></wbo-select-option>
                        <wbo-select-option [value]="'Profit $'"
                                           label="wbo.best-worst-sellers-report.option.order.profit"></wbo-select-option>
                    </wbo-select-options>
                </wbo-single-select-edit-control>
            </fui-column>
        </fui-two-columns>
    </fui-row>
</fui-rows>
